<template>
    <div>
        <div class="card-header">Tableau croisé dynamique</div>
        <b-card-body>
            <div class="row mb-3">
                <div class="col-4">
                    <search-client
                        size="sm"
                        :show-label="true"
                        search-url="/clients/search-with-prospects"
                        show-feedback="false"
                        @client-is-set="setClientId"
                        @searching-client="resetClient"
                    />
                </div>
                <div class="col-2">
                    <label>Année</label>
                    <b-form-input
                        v-model="year"
                        type="text"
                        size="sm"
                        @change="updateData"
                    />
                </div>
                <div class="col-2">
                    <label>Type d'année</label>
                    <b-form-select
                        v-model="yearType"
                        :options="yearTypeOptions"
                        size="sm"
                        class="mb-3"
                        @change="updateData"
                    />
                </div>
            </div>
            <WebDataRocks
                v-if="pivotDisplay"
                :report="pivotConfig"
                :global="pivotGlobal"
                toolbar
            />
        </b-card-body>
    </div>
</template>

<script>
import webDataRocksFrLocalization from '../../../../../../lang/fr/webDataRocksFrLocalization.json'

import WebDataRocks from '../../../common/components/WebDataRocks.vue'
import SearchClient from '../../clients/components/SearchClient.vue'

export default {
    name: 'PivotReport',

    components: {
        SearchClient,
        WebDataRocks,
    },

    data() {
        return {
            clientIsSet: false,
            client_id: 0,
            pivotDisplay: false,
            year: '',
            yearType: '',
            yearTypeOptions: [
                { text: 'Fiscale', value: 'fiscal' },
                { text: 'Calendaire', value: 'calendar' },
            ],
            pivotConfig: {
                dataSource: {},
                slice: {},
                options: {
                    grid: {
                        type: 'compact',
                        title: '',
                        showFilter: true,
                        showHeaders: false,
                        showTotals: true,
                        showGrandTotals: 'on',
                        showHierarchies: true,
                        showHierarchyCaptions: true,
                        showReportFiltersArea: true,
                    },
                    configuratorActive: false,
                    configuratorButton: true,
                    showAggregations: true,
                    showCalculatedValuesButton: true,
                    drillThrough: true,
                    showDrillThroughConfigurator: true,
                    sorting: 'on',
                    // datePattern: "dd/MM/yyyy",
                    datePattern: 'yyyy-MM-dd',
                    dateTimePattern: 'dd/MM/yyyy HH:mm:ss',
                    saveAllFormats: false,
                    showDefaultSlice: true,
                    defaultHierarchySortName: 'asc',
                },
                formats: [
                    {
                        name: '',
                        thousandsSeparator: ' ',
                        decimalSeparator: '.',
                        decimalPlaces: 0,
                        maxSymbols: 20,
                        currencySymbolAlign: 'right',
                        nullValue: ' ',
                        infinityValue: 'Infinity',
                        divideByZeroValue: 'Infinity',
                    },
                    {
                        name: '5bs5nt6v',
                        thousandsSeparator: ' ',
                        decimalSeparator: '.',
                        decimalPlaces: 2,
                        currencySymbol: '€',
                        currencySymbolAlign: 'right',
                        nullValue: ' ',
                        textAlign: 'right',
                        isPercent: false,
                    },
                ],
            },

            pivotGlobal: {
                localization: webDataRocksFrLocalization,
            },

            pivotData: [],
        }
    },

    async created() {
        this.year = new Date().getFullYear()
        this.yearType = 'fiscal'
        //   await this.getData()
        // const apiBaseURL = document.head.querySelector('meta[name="api-base-url"]').content
        // this.pivotConfig.dataSource.fileName = apiBaseURL + 'time-sheets/reporting/pivot'
    },

    methods: {
        showPivot() {
            this.pivotDisplay = true
        },

        hidePivot() {
            this.pivotDisplay = false
        },

        async setClientId(client) {
            this.client_id = client.id
            this.clientIsSet = true
            await this.getData()
            this.showPivot()
            this.updateKey()
        },

        resetClient() {
            this.client_id = 0
            this.clientIsSet = false
            this.hidePivot()
        },

        async updateData() {
            this.hidePivot()
            await this.getData()
            this.showPivot()
            this.updateKey()
        },

        async getData() {
            try {
                const response = await axios.get(
                    `/time-sheets/reporting/pivot/${this.client_id}/${this.yearType}/${this.year}`
                )
                this.pivotData = response.data
                this.setInitialReport()
            } catch (error) {
                console.log(error)
            }
        },

        updateKey() {
            this.key = Date.now()
        },

        setInitialReport() {
            this.ready = false
            this.pivotConfig.dataSource = { data: this.pivotData }
            ;(this.pivotConfig.slice = {
                rows: [
                    {
                        uniqueName: 'categorie',
                        sort: 'asc',
                    },
                    {
                        uniqueName: 'affectation',
                    },
                    {
                        uniqueName: 'initiales',
                    },
                    {
                        uniqueName: 'Measures',
                    },
                ],
                columns: [
                    {
                        uniqueName: 'date.Month',
                    },
                ],
                measures: [
                    {
                        uniqueName: 'duree',
                        aggregation: 'sum',
                    },
                ],
                expands: {
                    expandAll: false,
                },
                drills: {
                    drillAll: false,
                },
            }),
                (this.ready = true)
            this.key = Date.now()
        },
    },
}
</script>

<style scoped></style>
